import { z } from "zod";

export const TranslationLocaleSchema = z.enum(["en-gb", "sv"]);
export type TranslationLocale = z.infer<typeof TranslationLocaleSchema>;

export const PRIMARY_LOCALE = { code: "en-us" as const, label: "English (US)", flag: "🇺🇸" };

export const TRANSLATION_LOCALES: Record<TranslationLocale, { label: string; flag: string }> = {
  "en-gb": { label: "English (UK)", flag: "🇬🇧" },
  sv: { label: "Swedish", flag: "🇸🇪" },
};

export const LocaleSchema = z.enum(["en-us", "en-gb", "sv"]);
export type Locale = z.infer<typeof LocaleSchema>;

export const LocalizedTextSchema = z.record(
  LocaleSchema,
  z
    .string()
    .nullable()
    .transform(v => v ?? "")
);
export type LocalizedText = z.infer<typeof LocalizedTextSchema>;
